// ==============================|| STALE CHUNK AUTO-RELOAD ||============================== //
// După un deploy, un tab deschis ține index.html-ul vechi, care referă chunk-uri cu
// hash-uri vechi — șterse de pe server. Orice import dinamic (rută lazy) eșuează atunci
// cu „Failed to fetch dynamically imported module" / eroare de MIME (serverul întoarce
// index.html ca fallback SPA). Singura recuperare corectă e reîncărcarea paginii, care
// aduce index.html-ul nou cu hash-urile noi. Guard-ul pe sessionStorage previne bucla
// infinită dacă asset-ul lipsește din alt motiv (max o reîncărcare pe fereastra dată).

const RELOAD_GUARD_KEY = 'cityzen:chunk-reload-at';
const RELOAD_LOOP_WINDOW_MS = 30_000;

export const isStaleChunkError = (error: unknown): boolean => {
	const message = error instanceof Error ? error.message : String(error ?? '');
	return (
		/Failed to fetch dynamically imported module/i.test(message) ||
		/Importing a module script failed/i.test(message) ||
		/error loading dynamically imported module/i.test(message) ||
		/Unable to preload CSS/i.test(message)
	);
};

/** Reîncarcă pagina cel mult o dată per fereastră de timp; întoarce false dacă a
 *  reîncărcat deja recent (caz în care eroarea trebuie lăsată să se propage). */
export const reloadOnceForStaleChunk = (): boolean => {
	try {
		const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) ?? 0);
		if (Date.now() - last < RELOAD_LOOP_WINDOW_MS) return false;
		sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
	} catch {
		// sessionStorage indisponibil — reîncărcăm oricum (fără guard e totuși mai
		// bine decât un ecran de eroare permanent)
	}
	window.location.reload();
	return true;
};

/** Instalat o dată, la bootstrap: Vite emite `vite:preloadError` pentru chunk-urile
 *  dinamice eșuate — recuperăm transparent înainte ca eroarea să lovească React. */
export const installStaleChunkReload = (): void => {
	window.addEventListener('vite:preloadError', (event) => {
		if (reloadOnceForStaleChunk()) event.preventDefault();
	});
};
